import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectPage = (state: StoreSchema) =>
    state.clients.paginatedClients.currentPage
